import {
  useWSModalCustom,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useCallback } from "react";
import { BulkActionProgressCard } from "../components/BulkActionProgressCard";
import { BulkActionProgress } from "../types";

type Props = {
  actionName: string;
  result: BulkActionProgress;
} & WSModalCustomProps<void>;

const ModalBulkActionResults: React.FC<Props> = props => {
  const handleDone = useCallback(() => {
    props.onClose();
  }, [props]);

  return (
    <WSModal
      title={props.actionName}
      onClose={() => props.onClose()}
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Secondary",
            label: "Done",
            onClick: handleDone,
            type: "button"
          }
        ]
      }}
    >
      <WSList gap="M">
        <WSText.ParagraphSm color="gray500">
          Bulk action results:
        </WSText.ParagraphSm>

        <BulkActionProgressCard progress={props.result} />
      </WSList>
    </WSModal>
  );
};

export const useModalBulkActionResults = () =>
  useWSModalCustom(ModalBulkActionResults);
